import _ from 'lodash';
import Debug from '@/util/debug';
import clone from 'clone';
import debounce from 'debounce';
import deepEqual from 'deep-equal';
import { UNIT_KM } from '@/util/constants';
import 'vue-awesome/icons/refresh';
import offlineCheck from '@/mixins/offline-check';

const debug = Debug('reach-calculator');

const REACH_DEBOUNCE_TIME = 500; // ms

export default {
  dependencies: ['reachService', 'clusterService', 'genericConfigService'],
  props: {
    campaign: Object,
    reach: Number,
    cpm: Number,
    target: Object,
    unit: {
      type: String,
      default: UNIT_KM,
    },
  },
  mixins: [offlineCheck],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    refresh(target) {
      this.$emit('update:reach', null);
      this.$emit('update:loading', true);
      this.loading = true;
      this.requestReach(target);
    },
    sortPackages(packages, dir) {
      if (dir === 'desc') {
        return packages.sort((a, b) => b.reach.potential - a.reach.potential);
      }
      return packages.sort((a, b) => a.reach.potential - b.reach.potential);
    },
    packageReach(reach) {
      const availableClusters = _.cloneDeep(this.clusterService.availableClusters(this.campaign));

      if (availableClusters.length) {
        if (availableClusters[0].packages.length) {
          const ascList = this.sortPackages(availableClusters[0].packages, 'asc');
          const filtered = ascList.filter(p => p.reach.potential <= reach);

          if (filtered.length) {
            return this.sortPackages(filtered, 'desc')[0].reach.potential;
          }
          return reach;
        }
      }

      return reach;
    },
    requestReach: debounce(function debouncedRequestReach(target) {
      const fin = (cpm, reach, error = false) => {
        this.loading = false;
        this.$emit('update:reach', reach);
        this.$emit('update:cpm', cpm);
        this.$emit('update:loading', false);
        this.$emit('update:error', error);
      };

      const requestTarget = clone(target);

      this.reachService.getReach(requestTarget)
        .then(result => {
          let reach = result.users || 0;
          const cpm = result.cpm || 0;

          if (deepEqual(requestTarget, this.target)) {
            debug.info('current target reach: %d; cpm: %d', reach, cpm);

            this.genericConfigService.getConfig().then(c => {
              if (c.show_package_reach === '1') {
                reach = this.packageReach(reach);
              }
            }).then(() => fin(cpm, reach));
          } else {
            debug.info('old target %o reach: %d; cpm %d', requestTarget, reach, cpm);
          }

          if (result.estimate_ready === false) {
            this.$toast.error({ message: this.$t('pos.target.facebook-unable-to-provide-reach-estimate') });
          }
        })
        .catch(err => {
          if (deepEqual(requestTarget, this.target)) {
            debug.warn('error: %j', err);
            this.$toast.error({ message: err });
            fin(0, 0, true);
          } else {
            debug.warn('error for old target %o reach: %d; cpm %d', requestTarget, err);
          }
        });
    }, REACH_DEBOUNCE_TIME),
  },
  watch: {
    target: {
      deep: true,
      handler: function watchTarget(after) {
        this.refresh(after);
      },
    },
  },
  mounted() {
    this.refresh(this.target);
  },
};



// WEBPACK FOOTER //
// ./src/components/reach-calculator/ReachCalculator.js